import { api } from "./api";

export const settingView = (params) => {
  return api.get(`/manufacturer/settings/view`);
};

export const settingCreate = (params) => {
  return api.post(`/manufacturer/settings/create`, JSON.stringify(params));
};

export const accountViewApi = (params) => {
  return api.get(`/manufacturer/settings/my-profile`);
};

export const privacyPolicyViewApi = (params) => {
  return api.get(`/manufacturer/settings/policy`);
};

export const termsConditionViewApi = (params) => {
  return api.get(`/manufacturer/settings/terms`);
};

export const PrivacyPolicyEditApi = (params) => {
  return api.post(
    `/manufacturer/settings/policy-create`,
    JSON.stringify(params)
  );
};

export const termsConditionEditApi = (params) => {
  return api.post(
    `/manufacturer/settings/terms-create`,
    JSON.stringify(params)
  );
};
